import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCardText, [_vm.deletePrompt ? _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.announcement.confirmDeleteAnnouncements'),
      "open": _vm.deletePrompt,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.doDeleteAnnouncement(_vm.deleteAnnouncement);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.deleteAnnouncement.message) + "\n  ")]) : _vm._e(), _vm.loading ? [_c(VSkeletonLoader, {
    attrs: {
      "type": "table-thead"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-2",
    attrs: {
      "type": "table-row-divider@5"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-auto",
    attrs: {
      "type": "table-tfoot"
    }
  })] : _c(VRow, [_c(VDataTable, {
    staticClass: "table-width-100 px-4",
    class: {
      mobile: _vm.isMobile
    },
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "hide-default-header": _vm.isMobile,
      "items": _vm.maintenance,
      "expanded": _vm.expandedItems,
      "search": _vm.search,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id",
      "options": _vm.tableOptions
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination]
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [!_vm.isMobile ? _c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAnnouncementTableRow(props.item);
            }
          }
        }, [props.item.active ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-check-circle")]) : _vm._e(), !props.item.active ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-times-circle")]) : _vm._e()], 1), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAnnouncementTableRow(props.item);
            }
          }
        }, [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "500px"
          }
        }, [_vm._v(_vm._s(props.item.message))])]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAnnouncementTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(_vm.localizeDate(props.item.start)))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedAnnouncementTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(_vm.localizeDate(props.item.end)))]), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editAnnouncement(props.item);
            }
          }
        }, [_vm._v("\n              fal fa-edit\n            ")]), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteAnnouncement = props.item;
              _vm.deletePrompt = true;
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])], 1)]) : _c('tr', [_c('td', {
          staticClass: "table-td-mobile",
          on: {
            "click": function ($event) {
              return _vm.clickedAnnouncementTableRow(props.item);
            }
          }
        }, [_c('ul', {
          staticClass: "flex-content"
        }, [_c('li', {
          staticClass: "flex-item"
        }, [_c('label', {
          staticClass: "data-lable"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.active')))]), _c('p', [props.item.active ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-check")]) : _vm._e(), !props.item.active ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-times")]) : _vm._e()], 1)]), _c('li', {
          staticClass: "flex-item"
        }, [_c('label', {
          staticClass: "data-lable"
        }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.announcement')))]), _c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.message))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('label', {
          staticClass: "data-lable"
        }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.start')))]), _c('p', [_vm._v(_vm._s(_vm.localizeDate(props.item.start)))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('label', {
          staticClass: "data-lable"
        }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.end')))]), _c('p', [_vm._v(_vm._s(_vm.localizeDate(props.item.end)))])]), _c('li', {
          staticClass: "flex-item",
          attrs: {
            "data-label": "Action"
          }
        }, [_c('label', {
          staticClass: "data-lable"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.actions')))]), _c('p', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editAnnouncement(props.item);
            }
          }
        }, [_vm._v("\n                    fal fa-edit\n                  ")]), _vm._v("\n                   \n                  "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteAnnouncement = props.item;
              _vm.deletePrompt = true;
            }
          }
        }, [_vm._v("\n                    fal fa-trash-alt\n                  ")])], 1)])])])])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_c('div', {
          staticClass: "px-2 highlighted"
        }, [_c('p', {
          staticClass: "text-overline pt-1 mb-0 grey--text"
        }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.announcement.announcement')))]), _vm._v("\n              " + _vm._s(props.item.message) + "\n            ")]), _c('div', {
          staticClass: "mb-4"
        })])])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.lines')) + " " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n        " + _vm._s(props.itemsLength) + "\n      ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n        ")])];
      },
      proxy: true
    }])
  })], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };